import useStyles from "./styles"
import { Typography } from "@material-ui/core"
import { Link } from "react-router-dom"
import React from "react"

export function GridTitle({
    listView, onClick, product, to
}) {
    const classes = useStyles()
    return (
        listView
            ? (
                <Link
                    to={to}
                    onClick={onClick}
                    className={classes.noDisplayLink}
                >
                    <Typography
                        variant="h5"
                        gutterBottom
                    >
                        {product?.name}
                    </Typography>
                </Link>
            )
            : (
                <Typography variant="h5" gutterBottom>
                    {product?.name}
                </Typography>
            )
    )
}

export function ListTitle({ name }) {
    const classes = useStyles()
    return (
        <Typography
            variant="h5"
            className={classes.heading}
            gutterBottom
        >
            {name}
        </Typography>
    )
}

export function ModTekTitle({
    listView, to, onClick, product
}) {
    const classes = useStyles()
    return (
        listView
            ? (
                <Link
                    to={to}
                    onClick={onClick}
                    className={classes.noDisplayLink}
                >
                    <Typography
                        gutterBottom
                    >
                        {product?.name}
                    </Typography>
                </Link>
            )
            : (
                <Link
                    to={to}
                    onClick={onClick}
                    className={classes.noDisplayLink}
                >
                    <Typography gutterBottom>
                        {product?.name}
                    </Typography>
                </Link>
            )
    )
}
